import { render, staticRenderFns } from "./ModalError.vue?vue&type=template&id=5188800b"
import script from "./ModalError.vue?vue&type=script&lang=js"
export * from "./ModalError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5188800b')) {
      api.createRecord('5188800b', component.options)
    } else {
      api.reload('5188800b', component.options)
    }
    module.hot.accept("./ModalError.vue?vue&type=template&id=5188800b", function () {
      api.rerender('5188800b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalError.vue"
export default component.exports